import React, { FC, ReactNode, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Accordion from '@mui/material/Accordion';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    '&.MuiPaper-root.MuiAccordion-root': { 
      backgroundColor: 'rgba(0, 0, 0, .03)',
      margin: 0,
      marginBottom: '-8px',
    },
    '&.MuiAccordion-root:before': { display: 'none' },
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    minHeight: 'auto',
    '& .MuiAccordionSummary-root': {
      minHeight: 'auto',
      padding: '8px 16px 0px 16px',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiAccordionSummary-content': {
      margin: '0',
      display: 'flex',
      alignItems: 'center',
      // fontSize: '12rem',
      fontSize: '1.05rem',
      marginTop: '12px',
      marginBottom: '1px',
      '& .MuiTypography-root': {
        fontSize: '1.05rem',
      },
    },
    '& .MuiAccordionDetails-root': {
      padding: '0px 16px 0px 16px',
    },
  },
  rootExpanded: {
    overflow: 'hidden',
    '&.MuiPaper-root.MuiAccordion-root': { 
      backgroundColor: 'rgba(0, 0, 0, .03)',
      margin: 0,
      marginBottom: '-8px',
    },
    '&.MuiAccordion-root:before': { display: 'none' },
    '& > .MuiCollapse-root > .MuiCollapse-wrapper > .MuiCollapse-wrapperInner > div > .MuiAccordionDetails-root': {
      padding: '0px 16px 8px 16px',
      marginTop: '-14px',
    },
    '& .MuiAccordionSummary-root': {
      minHeight: 'auto',
      padding: '2px 16px 0px 16px',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiAccordionSummary-content': {
      margin: '0',
      display: 'flex',
      alignItems: 'center',
    },
  },
}));

interface IProps {
  children: NonNullable<ReactNode>;
}

export const ExcerptsAccordion: FC<IProps> = (props) => {
  const classes = useStyles();
  const { children } = props;
  const [excerptBox, setExcerptBox] = useState(false);
  const rootClass = excerptBox ? classes.rootExpanded : classes.root;

  return (
    <Accordion
      className={rootClass}
      square
      expanded={excerptBox}
      onChange={() => {
        setExcerptBox(!excerptBox);
      }}>
      {children}
    </Accordion>
  );
};

export default ExcerptsAccordion;
